import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { BLACK } from '../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../theme/fontConstants';
import { SAVE_STATUS } from '../../constants';
import { textFieldSx } from '../AutoSaveTextField';
import FieldLabel from '../FieldLabel';
import SaveStatusIndicator from '../SaveStatusIndicator';

const rootSx = {
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'wrap',
  gap: '16px',
  justifyContent: 'space-between',
  padding: '12px 0',
};

const textColumnSx = { display: 'flex', flexDirection: 'column', gap: '2px', minWidth: 0 };

const titleSx = { color: BLACK[100], fontFamily: PRIMARY_FONT[500], fontSize: '14px' };

const descriptionSx = { color: BLACK[70], fontFamily: PRIMARY_FONT[400], fontSize: '13px' };

const selectsSx = { display: 'flex', gap: '12px' };

const selectColumnSx = { display: 'flex', flexDirection: 'column', gap: '6px' };

const selectLabelRowSx = { alignItems: 'center', display: 'flex', gap: '8px' };

const selectLabelSx = { whiteSpace: 'nowrap' };

const selectSx = { ...textFieldSx, width: '170px' };

const PunchWindowsRow = ({ text, subText, selects }) => {
  const intl = useIntl();

  return (
    <Box sx={rootSx}>
      <Box sx={textColumnSx}>
        <Typography sx={titleSx}>{text}</Typography>
        <Typography sx={descriptionSx}>{subText}</Typography>
      </Box>
      <Box sx={selectsSx}>
        {selects.map(({ id, label, value, options, status, onChange }) => (
          <Box key={id} sx={selectColumnSx}>
            <Box sx={selectLabelRowSx}>
              <FieldLabel sx={selectLabelSx}>
                <span id={`${id}-label`}>{label}</span>
              </FieldLabel>
              <SaveStatusIndicator status={status} />
            </Box>
            <TextField
              id={id}
              select
              SelectProps={{ labelId: `${id}-label` }}
              size="small"
              value={value}
              onChange={(event) => onChange(Number(event.target.value))}
              sx={selectSx}
            >
              {options.map((minutes) => (
                <MenuItem key={minutes} value={minutes}>
                  {intl.formatMessage({ id: 'pt.detail.additionalInfo.minutes' }, { minutes })}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

PunchWindowsRow.propTypes = {
  text: PropTypes.string.isRequired,
  subText: PropTypes.string.isRequired,
  selects: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
      options: PropTypes.arrayOf(PropTypes.number).isRequired,
      status: PropTypes.oneOf(Object.values(SAVE_STATUS)),
      onChange: PropTypes.func.isRequired,
    })
  ).isRequired,
};

export default PunchWindowsRow;
